<template>
  <img :id="id" :data-src="src" v-bind="$attrs" />
</template>
<script>
export default {
  props: {
    src: String
  },
  data() {
    return {
      observer: null,
      img: null,
      id: ""
    };
  },
  created() {
    this.id =
      `lazy-image-${new Date().getTime()}` +
      Math.random()
        .toString(36)
        .substr(2, 9);
  },
  mounted() {
    this.img = document.getElementById(this.id);
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(item => {
        // isIntersecting是一个Boolean值，判断目标元素当前是否可见
        if (item.isIntersecting) {
          // @ts-ignore
          item.target.src = item.target.dataset.src;
          // 图片加载后即停止监听该元素
          this.observer.unobserve(item.target);
        }
      });
    });
    this.observer.observe(this.img);
  },
  beforeDestroy() {
    this.observer.unobserve(this.img);
  }
};
</script>
<style scoped>
img {
  min-width: 40px;
  min-height: 40px;
}
</style>
